import {Routes} from '@angular/router';
import {LoginComponent} from './system/login/login.component';
import {LayoutComponent} from './system/layout/layout.component';
import {AuthGuard} from './core/guard';
import {UnauthorizedComponent} from './system/unauthorized.component';
import {ForwardComponent} from './system/login/forward.component';

export const routes: Routes = [
  {
    path: '', component: LayoutComponent, canActivate: [AuthGuard], canActivateChild: [AuthGuard], children: [
      {path: '', redirectTo: 'dashboard', pathMatch: 'full'},
      {
        path: 'dashboard',
        loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardRoutingModule)
      },
      {
        path: 'internal',
        loadChildren: () => import('./modules/internal/internal.module').then(m => m.InternalRoutingModule)
      },
      {
        path: 'adms',
        loadChildren: () => import('./modules/adms/adms.module').then(m => m.AdmsRoutingModule)
      },
      {
        path: 'bpms',
        loadChildren: () => import('./modules/bpms/bpms.module').then(m => m.BpmsRoutingModule)
      },
      {
        path: 'mos',
        loadChildren: () => import('./modules/facility/facility.module').then(m => m.FacilityRoutingModule)
      },
      {
        path: 'reslife',
        loadChildren: () => import('./modules/reslife/reslife.module').then(m => m.ReslifeRoutingModule)
      },
      {
        path: 'nsy',
        loadChildren: () => import('./modules/nsy/nsy.module').then(m => m.NsyRoutingModule)
      }
    ]
  },
  {path: 'unauthorized', component: UnauthorizedComponent},
  {path: 'login', component: LoginComponent},
  {path: 'login/:token', component: LoginComponent},
  {path: 'redirect/:token', component: LoginComponent},
  {path: 'forward', component: ForwardComponent},
  {path: '**', redirectTo: 'login'}
];
